"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getInvoiceQuery = (0, _graphqlTag.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetInvoice($invoiceNumber: String!, $amount: Float!) {\n    getInvoice(invoiceNumber: $invoiceNumber, amount: $amount) {\n      checkoutId\n      priceId\n      invoiceId\n    }\n  }\n"])));

var getInvoice = function getInvoice() {
  return {
    query: getInvoiceQuery,
    module: 'finance',
    ignoreCache: true,
    buildVariables: function buildVariables(_ref) {
      var invoiceNumber = _ref.invoiceNumber,
          amount = _ref.amount;
      return {
        invoiceNumber: invoiceNumber,
        amount: amount
      };
    }
  };
};

var _default = getInvoice;
exports.default = _default;